// import logo from './logo.svg';
import './App.css';
import Home from './components/Home'
import Excel from './components/Excel'
import Sheets from './components/Sheets'
import LookerStudio from './components/LookerStudio'
import PowerPoint from './components/PowerPoint'
import PowerBI from './components/PowerBI'
import ChatGPT from './components/ChatGPT';
import Gemini from './components/Gemini';
import Sql from './components/Sql'
import Teams from './components/Teams'
import Sharepoint from './components/Sharepoint'

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

function App() {
  return (
    <Router>
    <div>
      <Routes>
        <Route path='/excel' element={<Excel/>} />
        <Route path='/sheets' element={<Sheets/>} />
        <Route path='/power-point' element={<PowerPoint/>} />
        <Route path='/power-bi' element={<PowerBI/>} />
        <Route path='/looker-studio' element={<LookerStudio/>} />
        <Route path='/sql' element={<Sql/>} />
        <Route path='/teams' element={<Teams/>} />
        <Route path='/sharepoint' element={<Sharepoint/>} />
        <Route path='/chatgpt' element={<ChatGPT/>} />
        <Route path='/gemini' element={<Gemini/>} />
        <Route path='/' element={<Home/>} />
      </Routes>
    </div>
  </Router>
  );
}

export default App;